import { ReactElement, ReactNode } from 'react';
import { useAppSelector } from 'redux/hooks';
import { useNavigate } from 'react-router-dom';
import { AppBar, Toolbar, Box, useTheme } from '@mui/material';
import KingspanLogo from '../../assets/images/KingspanLogo.svg';
import JorisIdeLogo from '../../assets/images/JorisIdeLogo.svg';
import { AccountInfo } from '../AccountInfo/AccountInfo';

type Props = {
  children?: ReactNode;
  'data-testid'?: string;
};

export const headerHeight = 95;
const breadcrumbGap = 40;

export function Header({ children, 'data-testid': testId = undefined }: Props): ReactElement {
  const theme = useTheme();
  const navigate = useNavigate();
  const division = useAppSelector((state) => state.user.division);
  const userName = useAppSelector((state) => state.user.name);

  return (
    <>
      <AppBar
        data-testid={testId}
        position="fixed"
        elevation={0}
        sx={{ borderBottom: '1px solid rgba(255, 255, 255, .12)', zIndex: theme.zIndex.drawer + 1 }}
      >
        <Toolbar sx={{ height: headerHeight }}>
          <img
            data-testid="headerLogo"
            src={division === 'joriside' ? JorisIdeLogo : KingspanLogo}
            alt={division === 'joriside' ? 'Joris Ide logo' : 'Kingspan logo'}
            height="48"
            width="230"
            onClick={() => navigate(`/${division}`)}
            style={{ cursor: 'pointer' }}
          />
          <Box sx={{ display: 'flex', justifyContent: 'center', width: '100%' }}>{children}</Box>
          <AccountInfo division={division} userName={userName} />
        </Toolbar>
      </AppBar>
      <Toolbar sx={{ height: headerHeight, marginBottom: `${breadcrumbGap}px` }} />
    </>
  );
}
